import { REDUX_ASYNC_STATUSES } from '../../consts/consts';

const isLoadingSelector = (statusKey) => (state) => state.insuredRisks[statusKey] === REDUX_ASYNC_STATUSES.LOADING;

export const selectInsuredRisks = (state) => state.insuredRisks?.insuredRisks;
export const selectAllInsuredRiskIds = (state) => state.insuredRisks?.insuredRisks?.map((risk) => risk.id) || [];
export const selectInsuredRisksLoading = isLoadingSelector('insuredRisksStatus');
